import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import axios from 'axios';

import './Navbar.css';
import ModalLoad from '../../components/modal/ModalLoad';
import ModalPopupMessage from '../../components/modal/ModalPopupMessage';
import Sidebar from '../../components/sidebar/Sidebar';

function Navbar(props) {
    const ref = useRef(null);
    const formpwdRef = useRef(null)
    const pwd_newRef = useRef(null)
    const pwd_confirmRef = useRef(null)
    const pwd_oldRef = useRef(null)

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const [modal_userinfo, setModal_userinfo] = useState(false);
    const [modal_password, setModal_password] = useState(false);
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    useEffect(() => {
        if (modal_userinfo === true) {
            var formelement = formpwdRef?.current
            if (formelement !== null) {
                formelement.classList.remove("was-validated");
            }
        }

        const handleOutSideClick = (event) => {
            if (!ref.current?.contains(event.target)) {
                if (modal_userinfo.class !== '') {
                    setModal_userinfo(false)
                }
            }
        };

        window.addEventListener("mousedown", handleOutSideClick);

        return () => {
            window.removeEventListener("mousedown", handleOutSideClick);
        };
    }, [ref, modal_userinfo]);

    async function api_changepassword() {
        var pass1 = pwd_newRef.current
        var pass2 = pwd_confirmRef.current
        var pass_o = pwd_oldRef.current
        if (pass1.value !== pass2.value) {
            pass2.setCustomValidity("Passwords Don't Match");
        } else {
            pass1.setCustomValidity("");
            pass2.setCustomValidity("");
            pass_o.setCustomValidity("");
            if (pass1.value === pass_o.value) {
                pass1.setCustomValidity("Passwords Don't Match");
                pass2.setCustomValidity("Passwords Don't Match");
                pass_o.setCustomValidity("Passwords Don't Match");
            }
        }

        var formelement = formpwdRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        } else {
            formelement.classList.remove("was-validated");
            const formdata = new FormData()
            formdata.append('username', props.permitdata?.username)
            formdata.append('password', pass2.value)

            setmodal_load({ enable: true, message: "Saving new password." })
            await sleep(500)
            var proxy = "/proxy/center"
            if (props.permitdata?.platform === 'local') {
                proxy = ""
            }
            axios.post("https://cpfsolar.sspv1.co.th/proxy/center/api/authentication/changepassword", formdata, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata?.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: 'Your password has been change, system will automatic signout for your account and apply apply new password within 5 minutes!',
                            enable: true
                        });
                    } else {
                        setModal_popup({ modaltype: 'modal-security', headers: 'Unauthorized', message: response.data.message, enable: true });
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_popup({
                        modaltype: 'modal-error', headers: 'Error', message: err.message, enable: true
                    });
                });
        }
    }

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
        if (modal_popup.modaltype === "modal-success") {
            props.callback_signout('x')
        }
    }

    function get_sitename(config) {
        if (config !== undefined) {
            if (config.sitename_th !== undefined && config.sitecode_txt !== undefined) {
                return config.sitename_th + " (" + config.sitecode_txt + ")"
            }
        }
        return ""
    }

    function getMobileAlarm() {
        if (window.screen.width < 576) {
            if (props.permitdata !== null && props.permitdata !== undefined) {
                if (props.permitdata?.view_mode !== null && props.permitdata?.view_mode !== undefined) {
                    if (props.permitdata?.view_mode === "local") {
                        if (props.local_alarmcount_alarm > 0) {
                            return "alarming"
                        }
                        if (props.local_alarmcount_warning > 0) {
                            return "warning-yellow"
                        }
                    }
                    if (props.permitdata?.view_mode === "center") {
                        if (props.center_alarmcount_offline > 0 || props.center_alarmcount_alarm > 0) {
                            return "alarming"
                        }
                        if (props.center_alarmcount_warning > 0) {
                            return "warning-yellow"
                        }
                    }
                }
            }
        }
        return ""
    }

    return (
        <>
            <header className="header ">
                <div className={"header__inner " + getMobileAlarm()}>
                    <div className="header__brand d-none d-md-flex">
                        <div className="brand-wrap">
                            {/* <Link className="brand-img stretched-link">
                                <img src="/images/logo.png" alt="Nifty Logo" className="Nifty logo" width="500" height="400" />
                            </Link> */}
                            {/* <Link className="brand-img stretched-link d-none">
                                <img src="/images/logo.png" alt="Nifty Logo" className="Nifty logo" width="500" height="400" />
                            </Link> */}
                            <div className='svp1-logo d-none'>SSPV1</div>
                            {/* <div className="brand-title font-popins">CPF</div> */}
                            <div className='d-block bt-line'>
                                <div className="brand-title-v2 font-popins">SHINING SPV 1 CO., LTD.</div>
                                <div className="brand-title-v2 font-sarabun">บริษัท ไชนิง เอสพีวี 1 จำกัด</div>
                            </div>
                        </div>
                    </div>

                    <div className="header__content">
                        <div className="header__content-start">
                            <button type="button" className="nav-toggler header__btn btn btn-icon btn-sm">
                                <i className="fe-menu"></i>
                            </button>

                            {
                                props.permitdata?.view_mode === "local" ?
                                    <div className="app-box">
                                        <h6 className="header-appname">CPF Local Solar Monitoring System</h6>
                                        {
                                            props.permitdata?.sitecode === "P3-13" && window.screen.width < 576 ?
                                                <p className="header-appname-sub appname-small">{get_sitename(props.data_uioption)}</p>
                                                :
                                                <p className="header-appname-sub ">{get_sitename(props.data_uioption)}</p>
                                        }
                                    </div>
                                    :
                                    <div className="app-box">
                                        <h6 className="header-appname">CPF Central Solar Monitoring System Phase 3</h6>
                                        {
                                            window.screen.width < 576 ?
                                                <p className="header-appname-sub appname-small">ศูนย์กลางข้อมูลระบบผลิตพลังงานไฟฟ้าแสงอาทิตย์ เฟส 3</p>
                                                :
                                                <p className="header-appname-sub ">ศูนย์กลางข้อมูลระบบผลิตพลังงานไฟฟ้าแสงอาทิตย์ เฟส 3</p>
                                        }
                                    </div>
                            }
                        </div>

                        <div className="header__content-end">
                            <div className='d-flex gap-2'>
                                {
                                    props.permitdata?.username === "admin" ?
                                        <div className='d-none d-md-block'>
                                            {props.center_ui_total_client}
                                        </div>
                                        :
                                        null
                                }
                                {
                                    props.local_data_ok === true && props.permitdata?.view_mode === "local" ?
                                        props.local_commonstatus?.upgrading === true ?
                                            <div className="common-alarm warning-orange d-none d-xl-block" >
                                                Upgrading
                                            </div>
                                            :
                                            null
                                        : null
                                }
                                {
                                    props.local_data_ok === true && props.permitdata?.view_mode === "local" ?
                                        props.local_indicator?.power_limit === true ?
                                            <div className="common-alarm warning-orange d-none d-md-block" >
                                                Power Limit
                                            </div>
                                            :
                                            null
                                        : null
                                }
                                {
                                    props.local_data_ok === true && props.permitdata?.view_mode === "local" ?
                                        props.local_indicator?.iot_restore_db_count > 0 ?
                                            <div className="common-alarm warning-yellow d-none d-xl-block" >
                                                IOT Restore ({props.local_indicator?.iot_restore_db_count})
                                            </div>
                                            :
                                            null
                                        : null
                                }
                                {
                                    props.local_data_ok === true && props.permitdata?.view_mode === "local" ?
                                        props.local_commonstatus?.center_chow_ok === true ?
                                            <div className="common-alarm normal d-none d-xl-block" >
                                                CHOW Center
                                            </div>
                                            :
                                            <div className="common-alarm warning-orange d-none d-xl-block" >
                                                CHOW Center
                                            </div>
                                        : null
                                }
                                {
                                    props.local_data_ok === true && props.permitdata?.view_mode === "local" ?
                                        props.local_commonstatus?.center_cpf_ok === true ?
                                            <div className="common-alarm normal d-none d-xl-block" >
                                                CPF Center
                                            </div>
                                            :
                                            <div className="common-alarm warning-orange d-none d-xl-block" >
                                                CPF Center
                                            </div>
                                        : null

                                }
                                {
                                    props.permitdata?.view_mode === "center" ?
                                        props.center_data_ok === true ?
                                            <Link to={"/appcenter/alarmevent/realtimeae"} className={"d-none d-sm-block common-alarm "
                                                + (props.center_alarmcount_offline > 0 || props.center_alarmcount_alarm > 0 ?
                                                    "alarming"
                                                    :
                                                    props.center_alarmcount_warning > 0 ?
                                                        "warning-yellow"
                                                        :
                                                        "normal"
                                                )}>
                                                {
                                                    props.center_alarmcount_offline > 0 || props.center_alarmcount_alarm > 0 ?
                                                        'System Alarm'
                                                        :
                                                        props.center_alarmcount_warning > 0 ?
                                                            "System Warning"
                                                            :
                                                            "System Normal"
                                                }
                                            </Link>
                                            :
                                            <Link to={"/appcenter/alarmevent/realtimeae"} className="d-none d-sm-block common-alarm " >Unknown System</Link>
                                        :
                                        null
                                }
                                {
                                    props.permitdata?.view_mode === "local" ?
                                        props.local_data_ok === true ?
                                            <Link to={"/applocal/alarmevent/realtimeae"} className={"d-none d-sm-block common-alarm "
                                                + (props.local_commonstatus?.alarmcount_alarm > 0 ?
                                                    "alarming"
                                                    :
                                                    props.local_commonstatus?.alarmcount_warning > 0 ?
                                                        "warning-yellow"
                                                        :
                                                        "normal"
                                                )}>
                                                {
                                                    props.local_commonstatus?.alarmcount_alarm > 0 ?
                                                        'System Alarm'
                                                        :
                                                        props.local_commonstatus?.alarmcount_warning > 0 ?
                                                            "System Warning"
                                                            :
                                                            "System Normal"
                                                }
                                            </Link>
                                            :
                                            <Link to={"/applocal/alarmevent/realtimeae"} className="d-none d-sm-block common-alarm " >Unknown System</Link>
                                        :
                                        null
                                }
                                {
                                    props.permitdata?.view_mode === "local" ?
                                        <div className={"d-none d-sm-block api-connection " + (
                                            props.local_api_state === 0 || props.local_api_state === -1 ?
                                                ""
                                                : props.local_api_state === 3 ?
                                                    "alarming"
                                                    :
                                                    "normal"
                                        )}>
                                            Local API
                                        </div>
                                        :
                                        null
                                }
                                {
                                    props.permitdata?.view_mode === "center" ?
                                        <div className={"d-none d-sm-block api-connection " + (
                                            props.center_api_state === 0 || props.center_api_state === -1 ?
                                                ""
                                                : props.center_api_state === 3 ?
                                                    "alarming"
                                                    :
                                                    "normal"
                                        )}>
                                            Center API
                                        </div>
                                        :
                                        null
                                }
                            </div>

                            <div className="dropdown usersbox d-none d-md-flex">
                                <button className="btn btn-sm " type="button" onClick={() => { setModal_userinfo(true) }} >
                                    <i className="fas fa-user-alt"></i> {props.permitdata?.username}
                                </button>

                                <div ref={ref} className={"dropdown-menu dropdown-menu-end w-md-350px " + (modal_userinfo === true ? "show" : "")} style={{ width: "350px", position: "absolute", zIndex: "5004", inset: "0px auto auto 0px", margin: "0px", transform: "translate(-257px, 34px)" }}>
                                    <div className="d-flex align-items-center border-bottom px-1 py-2">
                                        <div className="flex-grow-1 ms-3">
                                            <h5 className="mb-0"><i className="fas fa-user-shield username"></i> Hi! {props.permitdata?.username}</h5>
                                            <span className="text-dark">{props.permitdata?.email}</span>
                                            <div className="">Login time : {moment(new Date(props.permitdata?.logintime)).format('DD MMM YYYY HH:mm:ss')}</div>
                                        </div>
                                        <div className="font-poppins text-info">{props.permitdata?.user_role}</div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-8">
                                            <div className="list-group list-group-borderless h-100 py-1">
                                                {
                                                    props.permitdata?.username !== "admin" ?
                                                        < Link className="list-group-item list-group-item-action" onClick={() => { setModal_userinfo(false); setModal_password(true) }}>
                                                            <i className="fas fa-key fs-5 me-2" style={{ width: "15px" }}></i> Change Password
                                                        </Link>
                                                        :
                                                        null
                                                }
                                                <Link to="#" className="list-group-item list-group-item-action" onClick={() => { setModal_userinfo(false); props.callback_signout('x') }}>
                                                    <i className="fas fa-unlock-alt fs-5 me-2" style={{ width: "15px" }}></i> Logout
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </header >

            {
                modal_password ?
                    <div className='modal-overlay'>
                        <div className="modal d-block" >
                            <div className="modal-dialog modal-sm modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-body p-4">
                                        <div className="text-center">
                                            <i className="fas fa-key mt-1"></i>
                                            <h4 className="mt-2 font-popins">Change Your Password</h4>
                                            <form ref={formpwdRef}>
                                                <div className="row mb-3">
                                                    <div className="col-md-12 mb-3">
                                                        <div className="form-group">
                                                            <label htmlFor="old-password">Old Password</label>
                                                            <input type="password" className="form-control" ref={pwd_oldRef} name="old-password" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3">
                                                        <div className="form-group">
                                                            <label htmlFor="password">New Password</label>
                                                            <input type="password" className="form-control" ref={pwd_newRef} name="password" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" required />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <label htmlFor="confirm-password">Confirm new Password</label>
                                                            <input type="password" className="form-control" ref={pwd_confirmRef} name="confirm-password" pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" required />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={"d-md-flex justify-content-between"}>
                                                    <button type="button" className="btn btn-warning btn-sm my-2" onClick={() => api_changepassword()}>Confirm Change</button>
                                                    <button type="button" className="btn btn-light btn-sm my-2" onClick={() => { setModal_password(false) }}>Cancel</button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    null
            }

            <Sidebar
                permitdata={props.permitdata}
                app_hostname={props.app_hostname}
                data_systemconfig={props.data_systemconfig}
                callback_signout={message => { props.callback_signout('x') }}
            />
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onGeneral={PopupMsg_onGeneral} /> : null}
        </>
    )
}

export default Navbar